import { AnalyticEvent, AnalyticPayloads } from './registry';
import { Fennel } from './fennel';

const tracker = Fennel.getInstance();

export const fennelTrack = <E extends AnalyticEvent>(
  event: E,
  payload: AnalyticPayloads[E],
) => {
  tracker.track(event, payload);
};
